import { Component, OnInit } from '@angular/core';
import { FlashController } from '../../flash-payment-core/services/flash-controller.service';

@Component({
  selector: 'app-payment-summary',
  templateUrl: './payment-summary.component.html',
  styleUrls: ['./payment-summary.component.sass']
})
export class PaymentSummaryComponent implements OnInit {

  constructor(public flashPaymentService: FlashController) { }

  ngOnInit(): void {
  }

}
